var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a;
import { Component, Vue, Prop, Watch } from "vue-facing-decorator";
import { CompaniesClient, SitesClient, GetCompanySummaryPDFReportQuery, GetCompanySummaryDataQuery, ReportScheduleModel } from "@/app/api/battery-portal-api";
import { Notifier } from "@//common/utils/notifier";
import { HttpHelper } from "@/app/utils/http-helper";
import MonthYearPickerVue from "@/app/vues/reports/month-year-picker.vue";
import moment from "moment";
const companyClient = new CompaniesClient(window.apiUrl);
const siteClient = new SitesClient(window.apiUrl);
let CompanySummaryReportFilterVue = class CompanySummaryReportFilterVue extends Vue {
    constructor() {
        super(...arguments);
        this.working = false;
        this.statusFilterKey = 1;
        this.companies = [];
        this.sites = [];
        this.alarmStrategies = [
            { value: 0, text: 'Historical Alarms (from database)' },
            { value: 1, text: 'Calculated Alarms (based on limits)' }
        ];
        this.fromDate = null;
        this.toDate = null;
        this.companyId = null;
        this.siteId = null;
        this.alarmStrategy = 0;
        this.groupBySite = true;
        this.groupByCategory = false;
    }
    created() {
        this.getLookups();
        this.fromDate = moment().subtract(1, "months").startOf("month").toDate();
        this.toDate = moment().subtract(1, "months").endOf("month").toDate();
    }
    mounted() {
        this.loadReportScheduleQuery();
    }
    getLookups() {
        this.working = true;
        let promises = [
            companyClient
                .getListGET()
                .then(response => {
                let companies = (response || []).map((item) => {
                    return {
                        value: item.companyId,
                        text: item.companyName || ""
                    };
                });
                this.companies = companies;
            })
                .catch(ex => {
                HttpHelper.handleResponse(ex, () => {
                    Notifier.onServerError(ex);
                });
            })
                .finally(() => {
            }),
            siteClient
                .getListForUser()
                .then(response => {
                this.sites = response;
            })
        ];
        Promise.all(promises).then(() => {
            this.working = false;
        });
    }
    ;
    getQuery() {
        if (!this.companyId) {
            Notifier.onWarning("Please select a company.");
            return null;
        }
        ;
        let mainQuery = new GetCompanySummaryDataQuery({
            companyId: this.companyId,
            siteId: this.siteId,
            reportFromDate: this.fromDate ? moment(this.fromDate).startOf("month").toDate() : null,
            reportToDate: this.toDate ? moment(this.toDate).endOf("month").toDate() : null,
            groupBySite: this.groupBySite,
            groupByCategory: this.groupByCategory,
            alarmStrategy: this.alarmStrategy,
        });
        let reportQuery = new GetCompanySummaryPDFReportQuery({
            query: mainQuery,
        });
        return reportQuery;
    }
    generateSummaryStatusReport() {
        var reportQuery = this.getQuery();
        if (reportQuery == null)
            return;
        this.working = true;
        companyClient
            .downloadCompanySummaryAsPdf(reportQuery)
            .then(response => {
            if (!response) {
                Notifier.onWarning("Could not download the report.");
                return;
            }
            let blob = new Blob([response.data], { type: 'application/pdf;base64' });
            let url = URL.createObjectURL(blob);
            var popUp = window.open(url, '_blank');
            if (popUp == null || typeof (popUp) == 'undefined') {
                alert('Please disable your pop-up blocker and try again.');
            }
        })
            .catch(ex => {
            HttpHelper.handleResponse(ex, () => {
                Notifier.onServerError(ex);
            });
        })
            .finally(() => {
            this.working = false;
        });
    }
    getScheduleButtonLabel() {
        return this.reportScheduledModel ? "Update schedule" : "Schedule";
    }
    onReportScheduledModelChanged() {
        this.loadReportScheduleQuery();
    }
    schedule() {
        var reportQuery = this.getQuery();
        if (reportQuery == null)
            return;
        var queryString = JSON.stringify(reportQuery);
        this.$emit(this.reportScheduledModel ? "updateSchedule" : "schedule", queryString);
    }
    loadReportScheduleQuery() {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p;
        if (!this.reportScheduledModel)
            return;
        var queryString = (_b = (_a = this.reportScheduledModel) === null || _a === void 0 ? void 0 : _a.query) !== null && _b !== void 0 ? _b : "";
        try {
            this.working = true;
            var query = JSON.parse(queryString);
            this.companyId = (_d = (_c = query === null || query === void 0 ? void 0 : query.query) === null || _c === void 0 ? void 0 : _c.companyId) !== null && _d !== void 0 ? _d : null;
            this.siteId = (_f = (_e = query === null || query === void 0 ? void 0 : query.query) === null || _e === void 0 ? void 0 : _e.siteId) !== null && _f !== void 0 ? _f : null;
            this.fromDate = ((_g = query === null || query === void 0 ? void 0 : query.query) === null || _g === void 0 ? void 0 : _g.reportFromDate) ? moment(query.query.reportFromDate).toDate() : null;
            this.toDate = ((_h = query === null || query === void 0 ? void 0 : query.query) === null || _h === void 0 ? void 0 : _h.reportToDate) ? moment(query.query.reportToDate).toDate() : null;
            this.groupBySite = (_k = (_j = query === null || query === void 0 ? void 0 : query.query) === null || _j === void 0 ? void 0 : _j.groupBySite) !== null && _k !== void 0 ? _k : true;
            this.groupByCategory = (_m = (_l = query === null || query === void 0 ? void 0 : query.query) === null || _l === void 0 ? void 0 : _l.groupByCategory) !== null && _m !== void 0 ? _m : false;
            this.alarmStrategy = (_p = (_o = query === null || query === void 0 ? void 0 : query.query) === null || _o === void 0 ? void 0 : _o.alarmStrategy) !== null && _p !== void 0 ? _p : 0;
        }
        catch (ex) {
            console.error(ex);
        }
        finally {
            this.$nextTick(() => {
                this.working = false;
            });
        }
    }
    onCompanyIdChanged() {
        if (!this.working)
            this.siteId = null;
    }
    get selectedCompanyId() {
        return this.companies.filter(item => {
            return item.value == this.companyId;
        })[0] || null;
    }
    ;
    set selectedCompanyId(item) {
        if (!item)
            return;
        this.companyId = item.value;
    }
    ;
    get sitesFiltered() {
        if (!this.selectedCompanyId)
            return [];
        var filteredSites = this.sites.filter(site => !this.companyId || site.companyId == this.companyId);
        let sites = (filteredSites || []).map(item => {
            return {
                value: item.siteId,
                text: item.siteName || ""
            };
        });
        sites = [{ value: null, text: `All sites` }].concat(sites);
        return sites;
    }
    get selectedSite() {
        return this.sitesFiltered.filter(item => {
            return item.value == this.siteId;
        })[0] || null;
    }
    ;
    set selectedSite(item) {
        if (!item)
            return;
        this.siteId = item.value;
    }
    ;
    get selectedAlarmStrategy() {
        return this.alarmStrategies.filter(item => {
            return item.value == this.alarmStrategy;
        })[0] || this.alarmStrategies[0];
    }
    ;
    set selectedAlarmStrategy(item) {
        if (!item)
            return;
        this.alarmStrategy = item.value;
    }
    ;
};
__decorate([
    Prop(),
    __metadata("design:type", typeof (_a = typeof ReportScheduleModel !== "undefined" && ReportScheduleModel) === "function" ? _a : Object)
], CompanySummaryReportFilterVue.prototype, "reportScheduledModel", void 0);
__decorate([
    Watch("reportScheduledModel"),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], CompanySummaryReportFilterVue.prototype, "onReportScheduledModelChanged", null);
__decorate([
    Watch("companyId"),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], CompanySummaryReportFilterVue.prototype, "onCompanyIdChanged", null);
CompanySummaryReportFilterVue = __decorate([
    Component({
        name: "CompanySummaryReportFilterVue",
        emits: ["schedule", "updateSchedule"],
        components: {
            MonthYearPickerVue,
        }
    })
], CompanySummaryReportFilterVue);
export default CompanySummaryReportFilterVue;
